/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: useApiKeysColumns.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Hook for defining API Keys DataGrid columns.
────────────────────────────────────────────────────────────────*/

import { useMemo } from 'react';
import { useI18n } from '../../../hooks/useI18n';
import { DataGridColumn } from '../../../hooks/useDataGrid';

export function useApiKeysColumns() {
  const { t } = useI18n();

  const availableColumns = useMemo<DataGridColumn[]>(
    () => [
      { key: 'name', label: t('apiKeys.apiKeyName'), visible: true, sortable: true },
      { key: 'description', label: t('apiKeys.description'), visible: true, sortable: false },
      { key: 'keyPrefix', label: t('apiKeys.prefix'), visible: true, sortable: true },
      { key: 'tenant', label: t('common.tenant'), visible: true, sortable: true },
      { key: 'isActive', label: t('apiKeys.status'), visible: true, sortable: true },
      { key: 'lastUsedAt', label: t('apiKeys.lastUsed'), visible: true, sortable: true },
      { key: 'expiresAt', label: t('apiKeys.expiresAt'), visible: true, sortable: true },
      { key: 'creator', label: t('common.createdBy'), visible: true, sortable: true },
      { key: 'created_at', label: t('apiKeys.created'), visible: true, sortable: true },
      { key: 'actions', label: t('apiKeys.actions'), visible: true, sortable: false },
    ],
    [t],
  );

  return availableColumns;
}

